// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--1eHYB","content":"layout-module--content--i0A67"};